import * as THREE from 'three';

export const load = function (url, threeLoader, onComplete = ()=>{}, onProgress = ()=>{}, onError = ()=>{}) {
  return new Promise((resolve, reject) => {
    const loadHandler = (...args) => {resolve(onComplete(...args))};
    const progressHandler = (event) => {onProgress(event.loaded / event.total || 0, event.loaded || 0, event.total || 0)};
    const errorHandler = (...args) => {reject(onError(...args))};
    threeLoader.crossOrigin = true;
    threeLoader.load(url, loadHandler, progressHandler, errorHandler);
  });
}

export const loadList = function (urls, loadHelper, onProgress = ()=>{}) {
  if (urls.length === 0) return new Promise((resolve,reject) => resolve([]));
  return new Promise((resolve, reject) => {

    let countLoading = urls.length,
        list = [...Array(countLoading)],
        progressList = [...Array(countLoading)].fill(0),
        bytesLoadedList = [...Array(countLoading)].fill(0),
        bytesTotalList = [...Array(countLoading)].fill(0),
        totalProgress = 0,
        totalBytesLoaded = 0,
        totalBytesTotal = 0;

    const decrementCount = () => {
      countLoading--;
      if (countLoading === 0) resolve(list);
    };

    const progressHandler = id => (progress, loaded, total) => {
      progressList[id] = progress;
      bytesLoadedList[id] = loaded;
      bytesTotalList[id] = total;
      totalProgress = progressList.reduce((acc, value) => acc + value) / progressList.length
      totalBytesLoaded = bytesLoadedList.reduce((acc, value) => acc + value)
      totalBytesTotal = bytesTotalList.reduce((acc, value) => acc + value)
      onProgress(totalProgress, totalBytesLoaded, totalBytesTotal);
    };

    const onComplete = id => listItem => {
      list[id] = listItem;
      decrementCount();
    };

    const onError = error => {decrementCount()};
    const loadUrl = (url, id) => {loadHelper(url, progressHandler(id)).then(onComplete(id)).catch(onError)};
    urls.map(loadUrl);
  })
}

export const loadMesh = function (url, onProgress = ()=>{}) {
  const getName = () => url.slice(url.lastIndexOf('/') + 1, -5);
  const onComplete = (geom, mat) => {
    const mesh = new THREE.Mesh(geom, mat);
    mesh.name = getName();
    return mesh;
  };
  return load(url, new THREE.JSONLoader(), onComplete, onProgress);
}

export const loadMeshes = function (urls, onProgress = ()=>{}) {
  return loadList(urls, loadMesh, onProgress);
}

export const loadTexturedMaterial = function (url, onProgress = ()=>{}) {
  const onComplete = texture => new THREE.MeshBasicMaterial({ map: texture, transparent: true });
  return load(url, new AjaxTextureLoader(), onComplete, onProgress);
}

export const loadTexturedMaterials = function (urls, onProgress = ()=>{}) {
  return loadList(urls, loadTexturedMaterial, onProgress);
}

export const loadImage = function (url, onProgress = ()=>{}) {
  const cache = THREE.Cache;
  const onComplete = blob => {
    const objUrl = URL.createObjectURL(blob);
    const image = document.createElementNS('http://www.w3.org/1999/xhtml', 'img');

    image.onload = () => {
        cache.add(url, image);
        URL.revokeObjectURL(objUrl);
        if (image.parentNode === document.body) document.body.removeChild(image);
        image.style.visibility = 'visible';
    };

    document.body.appendChild(image);
    image.src = objUrl;
    image.style.visibility = 'hidden';

    return image;
  }
  const fileLoader = new THREE.FileLoader();
  fileLoader.setResponseType('blob');
  return load(url, fileLoader, onComplete, onProgress);
}

export const loadImages = function (urls, onProgress = ()=>{}) {
  return loadList(urls, loadImage, onProgress);
}

// https://github.com/mrdoob/three.js/issues/10439#issuecomment-293260145
const AjaxTextureLoader = function () {
  /**
   * Three's texture loader doesn't support onProgress events, because it uses image tags under the hood.
   *
   * A relatively simple workaround is to AJAX the file into the cache with a FileLoader, create an image from the Blob,
   * then extract that into a texture with a separate TextureLoader call.
   *
   * The cache is in memory, so this will work even if the server doesn't return a cache-control header.
   */

  const cache = THREE.Cache;

  // Turn on shared caching for FileLoader, ImageLoader and TextureLoader
  cache.enabled = true;

  const textureLoader = new THREE.TextureLoader();
  const fileLoader = new THREE.FileLoader();
  fileLoader.setResponseType('blob');

  function load(url, onLoad, onProgress, onError) {
      fileLoader.load(url, cacheImage, onProgress, onError);

      /**
       * The cache is currently storing a Blob, but we need to cast it to an Image
       * or else it won't work as a texture. TextureLoader won't do this automatically.
       */
      function cacheImage(blob) {
          // ObjectURLs should be released as soon as is safe, to free memory
          const objUrl = URL.createObjectURL(blob);
          const image = document.createElementNS('http://www.w3.org/1999/xhtml', 'img');

          image.onload = ()=> {
              cache.add(url, image);
              URL.revokeObjectURL(objUrl);
              document.body.removeChild(image);
              loadImageAsTexture();
          };

          image.src = objUrl;
          image.style.visibility = 'hidden';
          document.body.appendChild(image);
      }

      function loadImageAsTexture() {
          textureLoader.load(url, onLoad, ()=> {}, onError);
      }
  }

  return Object.assign({}, textureLoader, {load});
}


// WEBPACK FOOTER //
// ./src/scripts/helpers/ThreeLoaderHelper.js